<div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill>
  <div fxFlex="20" style="overflow: auto;height: 550px;">

    <ng-container [ngSwitch]="menuStatus">
      <ng-container *ngSwitchCase="'LOADING'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <ng-container *ngSwitchCase="'LOADED'">
        <kendo-treeview [filterable]="true" [nodes]="menu" textField="display" kendoTreeViewExpandable
          kendoTreeViewFlatDataBinding idField="id" parentIdField="parentId"
          (selectionChange)="onSelectionChange($event)">
        </kendo-treeview>
      </ng-container>
      <ng-container *ngSwitchCase="'NO-DATA'">
        <div style="margin: 48px;text-align: center;">No menus found</div>
      </ng-container>
    </ng-container>

  </div>
  <div fxFlex="40" style="overflow: auto;height: 550px;">
    <div *ngIf="selectedMenu"
      style="text-align: center;font-weight: 600;border-bottom-style: groove; border-bottom-width: 1px;margin: 16px;">
      {{selectedMenu?.display}}
    </div>
    <ng-container [ngSwitch]="menuProductStatus">
      <ng-container *ngSwitchCase="'LOADING'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <ng-container *ngSwitchCase="'LOADED'">
        <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

          <ng-container *ngFor="let product of menuProducts">
            <mat-card
              [ngClass]="{'selected-card':productDetails && productDetails.product.productId === product.productId}"
              class="product-card" style="margin: 16px" fxFlex="100" (click)="showProductDetails(product)">
              <mat-card-header>
                <div mat-card-avatar class="example-header-image"></div>
                <mat-card-title>{{product.productName}}</mat-card-title>
                <mat-card-subtitle>{{product.pdpTypeCode}} - {{product.pdpSubTypeCode}}</mat-card-subtitle>
              </mat-card-header>
              <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
              <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="16px grid">
                  <div>
                    <img style="margin: 8px;" [src]="product.imageLink" alt="">
                  </div>
                  <div>
                    place holder for more info
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>

        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'NO-DATA'">
        <div style="margin: 48px;text-align: center;">No products found</div>
      </ng-container>
      <ng-container *ngSwitchCase="'WAITING'">
        <div style="margin: 48px;text-align: center;">Select a menu to see it's products</div>
      </ng-container>
    </ng-container>
  </div>

  <div fxFlex="40" style="overflow: auto;height: 550px;">
    <div *ngIf="productDetails"
      style="text-align: center;font-weight: 600;border-bottom-style: groove;border-bottom-width: 1px;margin: 16px;">
      {{productDetails?.product?.productName}}
    </div>
    <ng-container [ngSwitch]="productStatus">
      <ng-container *ngSwitchCase="'LOADING'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <ng-container *ngSwitchCase="'LOADED'">
        <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

          <!-- <ng-container *ngIf="filters && filters.length > 0">
            <mat-card-subtitle>Select a configuration</mat-card-subtitle>
          </ng-container> -->

          <ng-container *ngFor="let filter of filters">
            <mat-form-field style="margin: 8px" fxFlex="100" width="100%">
              <mat-label>{{filter.display}}</mat-label>
              <mat-select [(ngModel)]="filter.value" (selectionChange)="filterChanged()">
                <mat-option *ngFor="let option of filter.options" [value]="option.value">
                  {{option.display}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>


          <ng-container *ngIf="selectedItem">
            <div style="margin: 8px; width: 100%">
              <ng-container *ngIf="selectedItem.images">
                <div
                  style="height: 320px;display: flex;width: 100%;flex-direction: row;flex-wrap: nowrap;align-content: space-between;align-items: center;justify-content: space-between;">
                  <div>
                    <button [disabled]="imageIndex === 0" mat-icon-button (click)="imageIndex = imageIndex - 1">
                      <mat-icon class="mat-18">arrow_back_ios</mat-icon>
                    </button>
                  </div>
                  <div>
                    <a target="_blank" [href]="selectedItem.images[imageIndex].imageOriginalLink">
                      <img style="margin: 8px;" [src]="selectedItem.images[imageIndex].imageLink" alt="">
                    </a>
                  </div>
                  <div>
                    <button [disabled]="imageIndex >= selectedItem.images.length - 1" mat-icon-button
                      (click)="imageIndex = imageIndex + 1">
                      <mat-icon class="mat-18">arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </div>
              </ng-container>

              <div
                style="width: 100%;display: flex;flex-direction: column;flex-wrap: nowrap;align-content: center;align-items: center;">

                <div style="width: 100%;display: flex;flex-direction: row;align-content: center;flex-wrap: nowrap;justify-content: space-between;align-items: flex-start;">
                  <div>
                    <table style="width: 100%">
                      <tr>
                        <th class="th-label">Stock Code</th>
                        <td class="td-value" style="text-align: right;" [routerLink]="">
                          <a target="_blank"
                            [routerLink]="'/generic/detail-page/stock-code-details/' + selectedItem.stockCode">
                            {{ selectedItem.stockCode }}
                          </a>
                        </td>
                      </tr>
                      <ng-container *ngIf="selectedItem.hasDiscount; else discountTemplate">
                        <tr>
                          <th class="th-label">RSP</th>
                          <td class="td-value" style="text-align: right;">
                            {{selectedItem.sellingPrice | number:'1.2-2'}}</td>
                        </tr>
                        <tr>
                          <th class="th-label">Discounted Price</th>
                          <td class="td-value" style="text-align: right;color: red">{{selectedItem.effectivePrice |
                            number:'1.2-2'}}</td>
                        </tr>
                      </ng-container>
                      <ng-template #discountTemplate>
                        <tr>
                          <th class="th-label">RSP</th>
                          <td class="td-value" style="text-align: right;">{{selectedItem.sellingPrice | number:'1.2-2'}}
                          </td>
                        </tr>
                      </ng-template>
                      <tr>
                        <th class="th-label">Lead Time</th>
                        <td class="td-value" style="text-align: right;">
                          {{selectedItem.leadTimeDesc}}</td>
                      </tr>
                      <tr>
                        <th class="th-label">Limited</th>
                        <td class="td-value" style="text-align: right;">
                          {{selectedItem.limited}}</td>
                      </tr>
                      <tr>
                        <th class="th-label">Full Hold</th>
                        <td class="td-value" style="text-align: right;">
                          {{selectedItem.fullHold}}</td>
                      </tr>
                      <tr>
                        <th class="th-label">SoF Allowed</th>
                        <td class="td-value" style="text-align: right;">
                          {{selectedItem.sofAllowed}}</td>
                      </tr>


                    </table>
                  </div>
                  <div>
                    <table style="width: 100%">
                      <ng-container *ngIf="selectedItem.soh && selectedItem.soh.length > 0;">
                        <tr *ngFor="let s of selectedItem.soh">
                          <th class="th-label">{{s.warehouseDescription}}</th>
                          <td class="td-value" style="text-align: right;">{{s.availableQty | number:'1.0-0'}}</td>
                        </tr>
                      </ng-container>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'NO-DATA'">
        <div style="margin: 48px;text-align: center;">No product details found</div>
      </ng-container>
      <ng-container *ngSwitchCase="'WAITING'">
        <div style="margin: 48px;text-align: center;">Select a product to see it's details</div>
      </ng-container>
    </ng-container>
  </div>
</div>
